require('./source/bootstrap.min');
require('./jquery-match-height-master/dist/jquery.matchHeight-min');
require('./vendor/slick.min');
require('./bootstrap-select.min');
require('./lazyload');
require('./swiper');
require('jquery-simplyscroll');

require('./source/main');
